// extracted by mini-css-extract-plugin
export default {"stockWrapper":"MarketingStockWrapper_stockWrapper__1lNRK","spinner":"MarketingStockWrapper_spinner__lw75n"};